export const paragraph = (text: string) => `<p>${text}</p>`
